<template>
  <div class="wl-create">
    <div class="wl-header-bar">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1>New Wine List</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="wl-body">
      <b-overlay :show="loading">
        <div class="container">
          <wine-list-settings
            v-model="settings"
            @valid="onValid"
          ></wine-list-settings>
          <div class="row">
            <div class="col-12">
              <b-button variant="primary" :disabled="!valid" @click="save"
                >Create Wine List</b-button
              >
              <p v-if="!valid" class="text-muted small mt-2">
                Enter a Title and Company Name to create the list.
              </p>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WineListSettings from "@/components/winelist/WineListSettings";

export default {
  components: {
    WineListSettings,
  },
  data() {
    return {
      settings: false,
      valid: false,
      loading: false,
    };
  },
  methods: {
    save() {
      if (this.valid) {
        this.loading = true;
        if(this.$route.params.sku) {
          this.settings.add_item = this.$route.params.sku;
        }
        this.$store
          .dispatch("winelist/create_new_list", this.settings)
          .then(() => {
            this.$router.push("/my-lists");
          })
          .catch((err) => {
            this.showError("Could not create list", err.response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$bvModal.msgBoxOk(
          "Please ensure all fields are filled out correctly."
        );
      }
    },
    onValid(state) {
      this.valid = state;
    },
  },
};
</script>
